import React from 'react'
import './DeleteCustomerDisplayModal.css'
import { Dialog, DialogContent } from '@mui/material'
import { t } from 'i18next'

const DeleteCustomerDisplayModal = ({
  showModalDeleteCustomerDisplay,
  setShowModalDeleteCustomerDisplay,
  handleConfirmDeleteCustomerDisplay,
}) => {
  const confirmState = async () => {
    await handleConfirmDeleteCustomerDisplay()
  }

  const onClose = () => {
    setShowModalDeleteCustomerDisplay(false)
  }

  return (
    <Dialog
      open={showModalDeleteCustomerDisplay}
      onClose={onClose}
      maxWidth="xs"
      data-testid="modal-delete-customer-display">
      <DialogContent className="customer-display-preview">
        <div>
          <div className="delete-customer-display-confirmation-message">
            <p className="delete-customer-display-confirmation-text">
              {t('CUSTOMER_DISPLAY_SETTINGS.LIST.DELETE_CONFIRM_TEXT')}
            </p>
          </div>
          <div className="delete-customer-display-modal-buttons">
            <button
              data-testid="btn-confirm-delete-customer-display"
              onClick={confirmState}
              className="btn modal-si">
              {t('CUSTOMER_DISPLAY_SETTINGS.LIST.YES_OPTION')}
            </button>
            <button
              data-testid="btn-cancel-delete-customer-display"
              onClick={onClose}
              className="btn modal-no">
              {t('CUSTOMER_DISPLAY_SETTINGS.LIST.NO_OPTION')}
            </button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default DeleteCustomerDisplayModal
